import Flex from "common/Boxes/Flex";
import { Gold, Platinum, Silver } from "common/Icons/Icons";
import { TIER_TO_DISPLAY_NAME } from "features/affiliation/common/constants";
import styled from "styled-components";
import { BoldTitle, SmallText } from "features/affiliation/common/styles";
import { CSSProperties } from "react";
import { Tier } from "types/affiliation.types";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";

import { LanguageNameSpaces } from "@shared/types";

interface TiersLocksProps {
  tiers: Tier[];
  currentTier: number;
  style?: CSSProperties;
}

const TiersLocks = ({ tiers, currentTier, style }: TiersLocksProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.AFFILIATION);

  return (
    <Wrapper style={style}>
      {tiers?.slice(0, 3).map((tierItem) => {
        const isLock = !!currentTier && currentTier < tierItem.tier;
        return (
          <TierWrapper $isLock={isLock} key={tierItem.tier}>
            <IconWrapper $isLock={isLock}>
              {TIER_TO_ICON[tierItem.tier]}
            </IconWrapper>
            <TitleWrapper>
              <BoldTitle type={isLock ? "secondary" : "primary"}>
                {t(TIER_TO_DISPLAY_NAME[tierItem.tier])}
              </BoldTitle>
              <SmallText>
                {t("tiers.tier_prefix")} {tierItem.tier}
              </SmallText>
            </TitleWrapper>
          </TierWrapper>
        );
      })}
    </Wrapper>
  );
};

export default TiersLocks;

const TIER_TO_ICON = {
  1: <Silver />,
  2: <Gold />,
  3: <Platinum />,
};

const Wrapper = styled(Flex)`
  position: relative;
  left: -12px;
`;
const TierWrapper = styled(Flex)<{ $isLock: boolean }>`
  opacity: ${(p) => (p.$isLock ? 0.6 : 1)};
`;
const TitleWrapper = styled.div`
  background: ${(p) => p.theme.colors.boxInCardColor};
  border-radius: 8px;
  padding: 4px 14px 4px 28px;
`;
const IconWrapper = styled.div<{ $isLock: boolean }>`
  position: relative;
  left: 22px;
  opacity: ${(p) => (p.$isLock ? 0.5 : 1)};
`;
